import React from 'react';
import { Paper } from '@material-ui/core';
import { useQuery } from '@apollo/client';
import { useGlobal, currentCountry } from '@rcg/ui-react';
import { formatPrice } from '@rcg/pricing-format';
import AffirmBox from '../AffirmBox';
import Button from '../UiComponents/Button';
import { prefixPathVar } from '../../operations/localState/reactiveVariables';
import useDictionary from '../../hooks/useDictionary';
import Dictionary from '../../utils/dictionary';
import { LDUser } from '../../utils/ldUser';
import { getCelebrityUrl } from '../../utils/common';
import {
  NAVIGATION_PATHS,
  BRAND,
  SESSION_STORAGE_BOOKING_PROFILE_NAME,
  APPLICATION_NAME,
  ENABLE_AFFIRM_FLAG,
  BOOKING_COUNTRY,
} from '../../utils/constants';
import { LAUNCH_DARKLY_FLAGS_AIR } from '../../operations/queries';

import getBrand from '../../utils/getBrand';
import useStyles from './style.index';

const PaymentDetails = ({ booking }) => {
  const classes = useStyles();
  const {
    data: { lang, localizedDayjs },
  } = useGlobal();
  const getDictionary = useDictionary(Dictionary);
  const isCelebrity = getBrand()?.id === BRAND.CELEBRITY;
  const launchDarklyParameters = JSON.parse(sessionStorage.getItem(BOOKING_COUNTRY)) || {
    country: 'USA',
    officeID: 'mia',
  };
  const flagsVariables = {
    ldUser: LDUser(),
    language: lang,
    clientApp: APPLICATION_NAME,
    application: APPLICATION_NAME,
    brand: getBrand()?.ldBrand,
    bookingCountry: launchDarklyParameters?.country,
    country: currentCountry().toUpperCase(),
  };
  const { data: initialFlags } = useQuery(LAUNCH_DARKLY_FLAGS_AIR, {
    fetchPolicy: 'no-cache',
    variables: flagsVariables,
  });

  const currency = booking?.price?.currencyCode;
  const balance = formatPrice(booking?.price?.balanceDue, currency, true, true, true);
  const balanceDue = localizedDayjs(booking?.price?.balanceDueDate).format('MMM D[,] YYYY');

  const goToPayment = () => {
    if (isCelebrity) {
      window.location.assign(getCelebrityUrl(NAVIGATION_PATHS.paymentCelebrity));
    } else {
      sessionStorage.setItem(SESSION_STORAGE_BOOKING_PROFILE_NAME, null);
      window.location.href = prefixPathVar() + NAVIGATION_PATHS.reservationPayment;
    }
  };

  const isBalance = booking?.price?.balanceDue > 0;
  const isAffirmEnabled = initialFlags?.ldFlags[ENABLE_AFFIRM_FLAG];
  return (
    <Paper className={classes.paymentRoot}>
      {booking && (
        <>
          <div className="payment-details">
            {isBalance ? (
              <>
                <div>
                  <span className="label">
                    {getDictionary(Dictionary.airPaymentDetailsBalanceLabel.key)}
                  </span>
                  <span className="value">{balance}</span>
                </div>
                <div>
                  <span className="label">
                    {' '}
                    {getDictionary(Dictionary.airPaymentDetailsDueDateLabel.key)}
                  </span>
                  <span className="value">{balanceDue}</span>
                </div>
                {isAffirmEnabled && (
                  <AffirmBox currency={currency} balance={booking?.price?.balanceDue} />
                )}
                <div>
                  {getDictionary(Dictionary.airPaymentDetailsDescription.key)} {balanceDue}
                </div>
              </>
            ) : (
              <div> {getDictionary(Dictionary.airPaymentDetailsFullPaidLabel.key)}</div>
            )}
          </div>
          <div className="payment-actions">
            {/* <Button variant="outlined" color="primary">
              {getDictionary(Dictionary.airPaymentDetailsBalanceCTA.key)}
            </Button> */}
            {isBalance && (
              <Button variant="contained" color="primary" onClick={goToPayment}>
                {getDictionary(Dictionary.airPaymentDetailsMakePaymentCTA.key)}
              </Button>
            )}
          </div>
        </>
      )}
    </Paper>
  );
};

export default PaymentDetails;
